/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function() {

    var config = {
      howManyToShow: 3,
      howManyToStoreInMemory: 10,
      wrapperId: 'recently-viewed-products',
      templateId: 'recently-viewed-product-template',
      onComplete: null,
      recentlySectionId: null
    };
  
    var productHandleQueue = [];
    var wrapper = null;
    var template = null;
    var shown = 0;
  
    var localStorageHandler = {
      name: 'shopify_recently_viewed',
      write: function(recentlyViewed) {
        localStorage.setItem(this.name, JSON.stringify(recentlyViewed));
      },
      read: function() {
        var recentlyViewed = localStorage.getItem(this.name);
        return recentlyViewed ? JSON.parse(recentlyViewed) : [];
      },
      destroy: function() {
        localStorage.removeItem(this.name);
      },
      remove: function(productHandle) {
        var recentlyViewed = this.read();
        var position = jQuery.inArray(productHandle, recentlyViewed);
        if (position !== -1) {
          recentlyViewed.splice(position, 1);
          this.write(recentlyViewed);
        }
      }
    };
  
    var finalize = function() {
      wrapper.show();
      // If we have a callback.
      if (config.onComplete) {
        try { config.onComplete(); } catch (error) { console.log(error); }
      }
    };
  
    var moveAlong = function() {
      if (productHandleQueue.length && shown < config.howManyToShow) {
        fetch(`/products/${productHandleQueue[0]}?sections=${config.recentlySectionId}`)
          .then((r) => r.json())
          .then(
            (d) => {
              wrapper.append(d[`${config.recentlySectionId}`]);
              productHandleQueue.shift();
              shown++;
              moveAlong();
            },
            (e) => {
              console.log(e);
              localStorageHandler.remove(productHandleQueue[0]);
              productHandleQueue.shift();
              moveAlong();
            }
        );
      } else {
        finalize();
      }
    };
  
    return {
  
      resizeImage: function(src, size) {
        if (size == null) {
          return src;
        }
  
        if (size == 'master') {
          return src.replace(/http(s)?:/, "");
        }
  
        var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
  
        if (match != null) {
          var prefix = src.split(match[0]);
          var suffix = match[0];
  
          return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
        } else {
          return null;
        }
      },
  
      showRecentlyViewed: function(params) {
        var params = params || {};
  
        // Update defaults.
        jQuery.extend(config, params);
  
        // Read from localStorage.
        productHandleQueue = localStorageHandler.read();
  
        // Template and element where to insert.
        wrapper = jQuery('#' + config.wrapperId);
  
        // How many products to show.
        config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);
  
        // If we have any to show.
        if (config.howManyToShow && wrapper.length) {
          // Getting each product with an Ajax call and rendering it on the page.
          moveAlong();
        }
      },
  
      getConfig: function() {
        return config;
      },
  
      clearList: function() {
        localStorageHandler.destroy();
      },
  
      recordRecentlyViewed: function(params) {
        //window.alert('recordRecentlyViewed function has been called.');
  
        var params = params || {};
  
        // Update defaults.
        jQuery.extend(config, params);
  
        // Read from localStorage.
        var recentlyViewed = localStorageHandler.read();
  
        // If we are on a product page.
        if (window.location.pathname.indexOf('/products/') !== -1) {
  
          // What is the product handle on this page.
          var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
          console.log('Product handle:', productHandle);
  
          // In what position is that product in memory.
          var position = jQuery.inArray(productHandle, recentlyViewed);
          console.log('Product position in list:', position);
  
          // If not in memory.
          if (position === -1) {
            // Add product at the start of the list.
            recentlyViewed.unshift(productHandle);
            console.log('Product added to recently viewed list:', recentlyViewed);
  
            // Only keep what we need.
            recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
          } else {
            // Remove the product and place it at start of list.
            recentlyViewed.splice(position, 1);
            recentlyViewed.unshift(productHandle);
            console.log('Product reordered in recently viewed list:', recentlyViewed);
          }
  
          // Update localStorage.
          localStorageHandler.write(recentlyViewed);
          console.log('LocalStorage updated with:', recentlyViewed);
        }
      }
    };
  })();
  